function formatDate(value, typeFormat = 'short') {
  if (value === '') {
    return;
  }
  const date = value == null ? new Date() : new Date(value);
  const formatter = new Intl.DateTimeFormat('pt-Br', { dateStyle: typeFormat });

  // eslint-disable-next-line consistent-return
  return formatter.format(date);
}

function formatTime(value, typeFormat = 'short') {
  const date = value == null ? new Date() : new Date(value);
  const formatter = new Intl.DateTimeFormat('pt-Br', { timeStyle: typeFormat });

  return formatter.format(date);
}

// O método getDay() retorna o dia da semana de 0-6, sendo Domingo = 0 e Sábado = 6.
function getWeekDay(date) {
  return date.getDay() + 1;
}

const getStringDateDefault = '1900-01-01T00:00:00.000Z';
const getStringDateDefaultLocate = '01/01/1900';
const getDateDefault = '1900-01-01T00:00:00';

const todayStart = new Date(new Date().setHours(0, 0, 0, 999));
const todayEnd = new Date(new Date().setHours(23, 59, 59, 999));

const tomorrowStart = new Date(new Date(new Date().setHours(0, 0, 0, 0)).setDate(new Date().getDate() + 1));
const tomorrowEnd = new Date(new Date(new Date().setHours(23, 59, 59, 999)).setDate(new Date().getDate() + 1));

const monthStart = new Date(new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(0, 0, 0, 0));
const monthEnd = new Date(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).setHours(23, 59, 59, 999));

const nextMonthStart = new Date(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).setHours(0, 0, 0, 0));
const nextMonthEnd = new Date(new Date(new Date().getFullYear(), new Date().getMonth() + 2, 0).setHours(23, 59, 59, 999));

function toStringDateTime(date) {
  const datePart = [date.getDate(), date.getMonth() + 1, date.getFullYear()].map((n, i) => n.toString().padStart(i === 2 ? 4 : 2, '0')).join('/');
  const timePart = [date.getHours(), date.getMinutes(), date.getSeconds()].map((n) => n.toString().padStart(2, '0')).join(':');
  return `${datePart} ${timePart}`;
}

function toDateTime(date) {
  const dateTime = new Date(date);
  const datePart = [dateTime.getDate(), dateTime.getMonth() + 1, dateTime.getFullYear()].map((n, i) => n.toString().padStart(i === 2 ? 4 : 2, '0')).join('/');
  const timePart = [dateTime.getHours(), dateTime.getMinutes(), dateTime.getSeconds()].map((n) => n.toString().padStart(2, '0')).join(':');
  return `${datePart} ${timePart}`;
}

// Converte uma data (string no formato dd/MM/yyyy ou Date) para o formato de mês abreviado e ano (MMM/yyyy),
function parseStringDate(value) {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return value;
  }

  const match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(String(value));

  if (!match) {
    return null;
  }

  return new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]));
}

// Retorna a chave de agrupamento mensal (yyyy-MM) de uma data (ex: 01/05/2026 => 2026-05).
function getMonthYearKey(value) {
  const date = parseStringDate(value);

  if (!date) {
    return value ?? '';
  }

  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
}

// Retorna a chave de agrupamento diária (yyyy-MM-dd) de uma data (ex: 01/05/2026 => 2026-05-01).
function getDateKey(value) {
  const date = parseStringDate(value);

  if (!date) {
    return value ?? '';
  }

  const dia = String(date.getDate()).padStart(2, '0');

  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${dia}`;
}

// Retorna o dia de uma data sempre com dois dígitos (ex: 03/09/2026 => 03).
function formatDayNumber(value) {
  const date = parseStringDate(value);

  if (!date) {
    return value ?? '';
  }

  return String(date.getDate()).padStart(2, '0');
}

// Retorna o dia e o mês abreviado de uma data, com o dia sempre com dois dígitos
function formatDayMonth(value) {
  const date = parseStringDate(value);

  if (!date) {
    return value ?? '';
  }

  const mes = new Intl.DateTimeFormat('pt-BR', { month: 'short' }).format(date).replace('.', '');

  return `${formatDayNumber(date)}/${mes}`;
}

// Retorna o mês abreviado e o ano de uma data (ex: 01/05/2026 => mai/2026).
function formatMonthYear(value) {
  const date = parseStringDate(value);

  if (!date) {
    return value ?? '';
  }

  const mes = new Intl.DateTimeFormat('pt-BR', { month: 'short' }).format(date);

  return `${mes}/${date.getFullYear()}`;
}

export default {
  formatDate,
  getStringDateDefault,
  getStringDateDefaultLocate,
  todayStart,
  todayEnd,
  tomorrowStart,
  tomorrowEnd,
  monthStart,
  monthEnd,
  nextMonthStart,
  nextMonthEnd,
  formatTime,
  getDateDefault,
  getWeekDay,
  toStringDateTime,
  toDateTime,
  parseStringDate,
  getMonthYearKey,
  getDateKey,
  formatDayNumber,
  formatDayMonth,
  formatMonthYear,
};
